function WorkoutCompletionModal({ onClose, onCompleteToday, onSelectDifferentDay, isCompleting }) {
    return (
        <div className="modal-overlay">
            <div className="modal-container tw-items-center tw-text-center" onClick={(e) => e.stopPropagation()}>
                <button 
                    onClick={onClose}
                    className="tw-absolute tw-top-6 tw-right-6 tw-bg-transparent tw-border-0 tw-text-5xl tw-cursor-pointer tw-text-gray-400 hover:tw-text-black"
                >
                    ×
                </button>

                <h1 className="modal-title tw-mb-4">
                    You Crushed That Workout! 🚀
                </h1>
                
                <p 
                    className="tw-m-0 tw-mb-8"
                    style={{
                        color: '#414042',
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '100%'
                    }}
                >
                    Check off your day to get credit for the workout
                </p>
                
                <button 
                    onClick={onCompleteToday}
                    disabled={isCompleting}
                    className="btn-primary tw-mb-4"
                >
                    {isCompleting ? 'COMPLETING...' : "COMPLETE TODAY'S WORKOUT"}
                </button>
                
                <button 
                    onClick={onSelectDifferentDay}
                    disabled={isCompleting}
                    className="btn-secondary"
                >
                    SELECT DIFFERENT DAY
                </button>
            </div>
        </div>
    );
}

export default WorkoutCompletionModal;
